<template>
  <div>
    <div class="box-margin">
      <Card>
        <Form
          :model="formItem"
          :label-width="100"
          label-position="left"
          :disabled="prevent"
        >
          <Row style="margin-bottom: 0">
            <Col span="6" >
              <FormItem label="员工工号:">
                <Input v-model="formItem.empCode"></Input>
              </FormItem>
            </Col>
            <Col span="6" offset='1'>
              <FormItem label="员工姓名:">
                <Input v-model="formItem.userName"></Input>
              </FormItem>
            </Col>
            <Col span="6" offset='1'>
              <FormItem label="职位:">
                <Input v-model="formItem.position"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row style="margin-bottom: 0">
            <Col span="6" >
              <FormItem :label="$t('formalTrialApproval.particularYear')+$t('mh')">
                <Date-picker
                  v-model="formItem.YY"
                  type="year"
                  :placeholder="$t('share.selectADate')"
                  :editable='false'
                ></Date-picker>
              </FormItem>
            </Col>
            <Col span="1" offset="1">
              <Button type="primary"><!-- 检索 -->{{$t('Search')}}</Button>
            </Col>
          </Row>
        </Form>
      </Card>
      <Table
        border
        :columns="columns1"
        :no-data-text="$t('noData')"
        :data="data1"
        :loading="modal_loading"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" @click="applyDetail(row)"
            >已修/申请明细</Button
          >
        </template>
      </Table>
      <Page style="display: flex;justify-content: flex-end;margin-top: 20px;" :current="pageInfo1.pageNo" :total="pageInfo1.itemCount" @on-change="pageChange1" />
    </div>
    <!-- 已休申請明細 -->
    <Modal :title="applyText" v-model="applyVisiable" width="70%">
      <Table
        height="330"
        show-summary
        :summary-method="handleSummary"
        border
        :columns="columns3"
        :data="data3"
        :loading="modal_loading"
      >
      </Table>
      <!-- <Page style="margin-top: 20px;display: flex;justify-content: flex-end;" :total="mxPageInfo.itemCount" @on-change="mxPageChange" /> -->
      <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import DateUtil from "../../../util/DateUtil";
import ModelUtils from "../../../util/ModelUtil";
import axios from "axios";
export default {
  data() {
    return {
      formItem: {},
      pageInfo1: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
      filter: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      mxPageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      totalNum: 0,
      prevent: false,
      modal_loading: false,
      config: false,
      selRow: {},
      titleText: this.$t('share.selectPeople'),
      applyText: this.$t('leavePaid.applicationDetails'),
      applyVisiable: false,
      date: new DateUtil(),
      columns1: [
        {
          title: "员工工号",
          key: "empcode",
          width: "135",
          align: "center",
          fixed: "left"
        },
        {
          title: "姓名",
          key: "empcname",
          width: "130",
          align: "center",
          fixed: "left"
        },
        
        {
          title: "公司",
          key: "orgsname2",
          width: "150",
          align: "center",
        },
        {
          title: "地区",
          key: "orgsname4",
          width: "150",
          align: "center",
        },
        {
          title: "职位",
          key: "position_name",
          width: "150",
          align: "center",
        },
        {
          title:"年份",
          key: "YY",
          align: "center",
          width: 150,
        },
        {
          title: "可休",
          align: "center",
          children: [
            {
              title: "日数",
              key: "effective_dd",
              width: "150",
              align: "center",
            },
            {
              title: "剩余时数",
              key: "effective_hh",
              width: "150",
              align: "center",
            },
          ],
        },
        {
          title: "已休",
          align: "center",
          children: [
            {
              title:"日数",
              key: "used_dd",
              width: "150",
              align: "center",
            },
            {
              title: "时数",
              key: "used_hh",
              width: "150",
              align: "center",
            },
          ],
        },
        {
          title: "申请",
          align: "center",
          children: [
          {
              title:"日数",
              key: "apply_dd",
              width: "150",
              align: "center",
            },
            {
              title: "时数",
              key: "apply_hh",
              width: "150",
              align: "center",
            },
          ],
        },
        {
          title: "剩余",
          align: "center",
          children: [
          {
              title:"日数",
              key: "lst_dd",
              width: "100",
              align: "center",
            },
            {
              title: "时数",
              key: "lst_hh",
              width: "100",
              align: "center",
            },
          ],
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      data1: [
      {
              empcode : "0001",
              empcname : "陈凯",
              orgsname2 : "PL",
              orgsname4 :	"China",
              position_name : "总裁"	,
              YY : "2022"	,
              effective_dd : "1",
              effective_hh : "8",
              used_dd : "1",
              used_hh : "8",
              apply_dd : "0.5",
              apply_hh : "4",
              lst_dd : "1",
              lst_hh : "8",
          },
          {
              empcode : "0001",
              empcname : "陈凯",
              orgsname2 : "PL",
              orgsname4 :	"China",
              position_name : "总裁"	,
              YY : "2021"	,
              effective_dd : "1",
              effective_hh : "8",
              used_dd : "1",
              used_hh : "8",
              apply_dd : "0.5",
              apply_hh : "4",
              lst_dd : "1",
              lst_hh : "8",
          }
      ],
      columns3: [
        {
          title: "休假类型",
          key: "leavecname",
          align: "center",
          width: "150",
        },
        {
          title: "休假开始时间",
          align: "center",
          children: [
            {
              title: "日期",
              key: "begindt",
              align: "center",
              width: "150",
            },
            {
              title: "时间",
              key: "begintime",
              align: "center",
              width: "100",
              
            },
          ],
        },
        {
          title: "休假结束时间",
          align: "center",
          children: [
            {
              title:"日期",
              key: "enddt",
              width: "150",
              align: "center",
            },
            {
              title: "时间",
              key: "endtime",
              width: "100",
              align: "center",
             
            },
          ],
        },
        {
          title: "日数",
          key: "leavetime_dd",
          align: "center",
          width: "150",
        },
        {
          title:"时数",
          key: "leavetime_hh",
          align: "center",
          width: "150",
        },
        {
          title: "申请单号",
          key: "order_no",
          width: "180",
          align: "center",
        },
        {
          title: "申请单状态",
          key: "status_nm",
          width: "180",
          align: "center",
        },
      ],
      data3: [
      {
              leavecname : "特别休假",
              begindt :"2022-04-01",
              begintime:"08:30",
              enddt : "2022-04-01",
              endtime : "17:30",
              leavetime_dd : "1",
              leavetime_hh : "8",
              order_no : "LV-2204-00002",
              status_nm : "申请通过"
          },
          {
              leavecname : "婚假",
              begindt :"2021-05-01",
              begintime:"08:30",
              enddt : "2021-05-10",
              endtime : "17:30",
              leavetime_dd : "10",
              leavetime_hh : "80",
              order_no : "LV-2104-00015",
              status_nm : "申请通过"
          },
      ],
      rsztList: []
    };
  },
  watch: {},
  mounted() {
  //   this.getUserInfo()
  //   this.getRsList()
  //   this.formItem.empcode = JSON.parse(window.sessionStorage.getItem("userInfo")).loginUserId
  },
  updated(){
  //   this.empty();
  },
  methods: {
    getRsList() {
      let arr = [{
                objData1: {"type": "sel80"},
                stringData1: "3895D2E31429A185125E4D3809053EB7",
                stringData2: "A3FFBEBFDB713E27",
                stringData3: "22",
                type: "P00"
            }];
      axios.post("/api/process/execute", arr).then(res => {
          if (res) {
              this.rsztList = res[0];
          }
      });
    },
    getUserInfo() {
      let arr = [
        {
          type: "P00",
          objData1: { emp_code: JSON.parse(sessionStorage.getItem("userInfo")).loginUserId },
          stringData1: "3895D2E31429A185125E4D3809053EB7",
          stringData2: "A3FFBEBFDB713E27",
          stringData3: "3",
        },
      ];
      axios.post("/api/process/execute", arr).then((res) => {
          // this.formItem.orgsname2 = res[0].orgsname2
          // this.formItem.orgsname4 = res[0].orgsname4
          // this.formItem.orgsname5 = res[0].orgsname5
          // this.formItem.orgsname6 = res[0].orgsname6
          // this.formItem.orgsname7 = res[0].orgsname7
          this.formItem.YY = new Date()
          this.mainSearch();
      });
    },
    
    getMX() {
      // this.modal_loading = true
      // let arr = [
      //   {
      //     type: "P00",
      //     objData1: {emp_code: this.selRow.empcode || '', YY: this.selRow.YY},
      //     stringData1: "3895D2E31429A185125E4D3809053EB7",
      //     stringData2: "A3FFBEBFDB713E27",
      //     stringData3: "2",
      //   },
      // ];
      // axios.post("/api/process/execute", arr).then((res) => {
      //   this.modal_loading = false;
      //   this.prevent = false
      //   this.data3 = res[0];
      // });
    },
    pageChange1(i) {
            this.pageInfo1.pageNo = i
            this.mainSearch()
        },
    // 主頁面查詢功能
    mainSearch() {
      this.modal_loading = true;
      this.prevent = true
      this.formItem.YY ? this.formItem.YY = this.date.dateVal(this.formItem.YY,'YYYY') : ''
      let arr = [
        {
          type: "leavePaid",
          // stringData1: "3895D2E31429A185125E4D3809053EB7",
          // stringData2: "A3FFBEBFDB713E27",
          // stringData3: "1",
          stringData5: "1",
          objData2: { pageNo: this.pageInfo1.pageNo },
          objData1: { ...this.formItem },
        },
      ];
      axios.post("/api/process/execute", arr).then((res) => {
        this.modal_loading = false;
        this.prevent = false
        this.data1 = res[0].dataList;
        this.pageInfo1 = res[0].pageInfo
      });
    },
    //清空表单
    empty(){
      if(!this.config){
        this.filter.emp_code = '';
        this.filter.user_name = '';
        this.filter.orgsname2 ='';
        this.filter.orgsname4 = '';
      }
    },
    // 分页点击事件
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.filterFunction();
    },
    // 人事代號搜索事件
    selectSearch() {
      this.config = true;
      this.filterFunction();
    },
    // 選擇人員頁面查詢功能
    filterFunction() {
      // this.modal_loading = true;
      // let arr = [
      //   {
      //     type: "P00",
      //     stringData1: "C27A6B965609DE33487F11DBA56BD96C",
      //     stringData2: "A3FFBEBFDB713E27",
      //     objData1: { ...this.filter },
      //     objData2: {
      //       pageNo: this.pageInfo.pageNo,
      //     },
      //     stringData3: "2",
      //   },
      // ];
      // axios.post("/api/process/execute", arr).then((res) => {
      //   this.modal_loading = false;
      //   this.data2 = res[0].dataList;
      //   this.totalNum = res[0].pageInfo.itemCount;
      // });
    },
    //    选中行数据
    show(row) {
      this.formItem = row;
      this.config = false;
    },
    // 點擊申請詳細事件
    applyDetail(row) {
      this.applyVisiable = true;
      this.selRow = row
      this.getMX()
    },
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 4) {
          sums[key] = {
            key,
            value: this.$t('szfzsxbzInfo.subTotal'),
          };
          return;
        } else if (index === 5 || index === 6) {
          const values = data.map((item) => Number(item[key]));
          if (!values.every((value) => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[key] = {
              key,
              value: v.toFixed(1),
            };
          } else {
            sums[key] = {
              key,
              value: "",
            };
          }
        } else {
          sums[key] = {
            key,
            value: "",
          };
        }
      });

      return sums;
    },
  },
};
</script>
<style  scoped>
.box-margin {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/EmployeeLvSurPlus.vue